// removed by extract-text-webpack-plugin
module.exports = {"editbox-wrapper":"index__editbox-wrapper___AXMWF","editbox-element":"index__editbox-element___1cpA5","editbox-value":"index__editbox-value___1sYif","editbox-value-wrapper":"index__editbox-value-wrapper___2oylo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/editBox/index.less
// module id = 1086
// module chunks = 3